// extracted by mini-css-extract-plugin
export default {"shadowed":"Portfolio_shadowed__fJM3v","portfolioBlock":"Portfolio_portfolioBlock__C5DAo","projecticon":"Portfolio_projecticon__U8i3w","projectDesc":"Portfolio_projectDesc__k9YYr"};